module.exports = __webpack_public_path__ + "img/rock.2dd2d049.jpg";